import Quill from 'quill'

// FONT FAMILY
const Font = Quill.import('formats/font')
Font.whitelist = [
  'arial',
  'courier-new',
  'georgia',
  'impact',
  'lucida-console',
  'tahoma',
  'times-new-roman',
  'trebuchet-ms',
  'verdana',
]
Quill.register(Font, true)

// FONT SIZE
const Size = Quill.import('attributors/style/size')
Size.whitelist = ['12px', '14px', '16px', '18px', '24px', '32px', '48px']
Quill.register(Size, true)
